export default __webpack_public_path__ + "static/media/mask-group-517.beb8dafb.png";